
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faEnvelope, faUnlockAlt } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, FormCheck, Container, InputGroup } from '@themesberg/react-bootstrap';
import React, {useContext, useState} from "react";
import {AuthContext} from "../context/AuthProvider";

import BgImage from "../assets/img/illustrations/signin.svg";


export default function Login() {
  const {login} = useContext(AuthContext);
    const [error, setError] = useState(null)

    const [data, setData] = useState({
        email: '',
        password: '',
        group: "admin",
    })

    const handleData = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const doLogin = () => {
        login(data, setError);
    }


  return (
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center form-bg-image" style={{ backgroundImage: `url(${BgImage})` }}>
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Ingreso a sistema de administración</h3>
                                                    {error != null ? (
                                                        <div className="alert alert-danger" role="alert">
                                                            {error}
                                                        </div>
                                ) : null}
                </div>
                <Form className="mt-4">
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faEnvelope} />
                      </InputGroup.Text>
                      <Form.Control autoFocus onChange={handleData}  type="email" name="email" placeholder="example@company.com" />
                    </InputGroup>
                  </Form.Group>
                  <Form.Group>
                    <Form.Group id="password" className="mb-4">
                      <Form.Label>Contraseña</Form.Label>
                      <InputGroup>
                        <InputGroup.Text>
                          <FontAwesomeIcon icon={faUnlockAlt} />
                        </InputGroup.Text>
                        <Form.Control onChange={handleData} type="password" name="password" placeholder="Contraseña" />
                      </InputGroup>
                    </Form.Group>
                  </Form.Group>
                  <Button variant="primary" type="button" className="w-100" onClick={() => doLogin()}>

                    Ingresar
                  </Button>
                </Form>


              </div>
            </Col>
          </Row>
        </Container>
      </section>
  );
};
